module.exports = {
  "widget": {
    "height": "88"
  },
  "tab-margin": {
    "marginBottom": "16"
  },
  "tab-padding-160": {
    "paddingTop": 0,
    "paddingRight": "160",
    "paddingBottom": 0,
    "paddingLeft": "160"
  },
  "tab-padding-40": {
    "paddingTop": 0,
    "paddingRight": "40",
    "paddingBottom": 0,
    "paddingLeft": "40"
  },
  "flex-expand-layout": {
    "flex": 1
  },
  "tab-title-list": {
    "flexDirection": "row",
    "justifyContent": "space-between",
    "paddingTop": 0,
    "paddingRight": "16",
    "paddingBottom": 0,
    "paddingLeft": "16"
  },
  "space-around-layout": {
    "justifyContent": "space-around"
  },
  "flex-start-layout": {
    "justifyContent": "flex-start",
    "flex": 1
  },
  "flex-start-item": {
    "marginRight": "32"
  },
  "padding-layout-32": {
    "paddingTop": 0,
    "paddingRight": "32",
    "paddingBottom": 0,
    "paddingLeft": "32"
  },
  "padding-layout-8": {
    "paddingTop": 0,
    "paddingRight": "8",
    "paddingBottom": 0,
    "paddingLeft": "8"
  },
  "title-item": {
    "height": "88",
    "justifyContent": "center",
    "alignItems": "stretch",
    "borderBottomStyle": "solid"
  },
  "title-item-primary": {
    "alignItems": "center"
  },
  "tab-text-wrapper": {
    "height": "82",
    "justifyContent": "center"
  },
  "minibar-inner": {
    "height": "76"
  },
  "thidrd-wrapper": {
    "flexDirection": "row",
    "height": "52",
    "paddingTop": 0,
    "paddingRight": "30",
    "paddingBottom": 0,
    "paddingLeft": "30",
    "borderRadius": "26",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "avatar-icon": {
    "width": "36",
    "height": "36",
    "marginRight": "8"
  },
  "tab-text": {
    "lines": 1,
    "textOverflow": "ellipsis",
    "fontFamily": "PingFangSC-Regular",
    "letterSpacing": 0
  },
  "third-text": {
    "fontSize": "24"
  },
  "border-bottom-line": {
    "width": "40",
    "height": "6",
    "borderRadius": "3",
    "marginTop": "-10"
  },
  "border-bottom-line-secondary": {
    "height": "4",
    "borderRadius": "3",
    "marginTop": "-2"
  },
  "thirdTabPanel": {
    "height": "128"
  },
  "dof-third-panel": {
    "height": "128",
    "flexDirection": "row",
    "flexWrap": "nowrap",
    "alignItems": "center",
    "justifyContent": "center",
    "opacity": 1
  },
  "btn-group-wrap": {
    "flexDirection": "row",
    "flexWrap": "nowrap",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "64"
  },
  "btn-text": {
    "fontFamily": "PingFangSC-Regular",
    "color": "#ffffff",
    "fontSize": "28",
    "lineHeight": "64",
    "paddingLeft": "32",
    "paddingRight": "32"
  },
  "leftRadius": {
    "borderTopLeftRadius": "32",
    "borderBottomLeftRadius": "32"
  },
  "rightRadius": {
    "borderTopRightRadius": "32",
    "borderBottomRightRadius": "32"
  },
  "dot-tip": {
    "marginTop": "6",
    "width": "16",
    "height": "16",
    "borderRadius": "10",
    "backgroundColor": "#f56428"
  },
  "dot-tab-text": {
    "paddingTop": "10",
    "paddingBottom": "8"
  },
  "flexDirection": {
    "position": "relative",
    "flexDirection": "row",
    "alignItems": "flex-start"
  },
  "dot-num-tip-text": {
    "fontSize": "24",
    "color": "#ffffff",
    "borderRadius": "100",
    "backgroundColor": "#f56428",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingLeft": "8",
    "paddingRight": "8",
    "marginLeft": "-16"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-728a62c0!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-tab-page/index.vue
// module id = 515
// module chunks = 0 1